import {
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    RESET_MESSAGE,
    LOGIN_PROGRESS,
    LOGOUT_PROGRESS,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE,
} from '../../types/actionTypes';

const initialState = {
    loginUser: null,
    error: null,
    loading: false,
    message: null
};

const login_reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_PROGRESS:
            return { ...state, loading: true };
        case LOGIN_SUCCESS:
            return { ...state, loginUser: action.payload.result, loading: false, error: null, message: action.payload.message };
        case LOGIN_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case LOGOUT_PROGRESS:
            return { ...state, loading: true };
        case LOGOUT_SUCCESS:
            return { ...state, loginUser: null, loading: false, error: null };
        case LOGOUT_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case RESET_MESSAGE:
            return { ...state, message: null };
        default:
            return state;
    }
}

export default login_reducer;